import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button, Table } from 'antd'
import { search } from '@services/api'
import weightsTexts from '@texts/weights'
import moment from 'moment'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
export default class EditSiteContentPopup extends Component<any, any> {
    constructor() {
        super()
        this.handleClose = this.handleClose.bind(this)
        this.state = {
            history: []
        }
    }

    async componentDidUpdate() {
        let {
            info: { type, subType },
            popupType
        } = this.props.popupStore

        if (popupType == 'searchWeightHistory' && !this.state.history.length) {
            await search
                .getSearchWeights({ type, subType, size: 100 })
                .then(result => this.setState({ history: result.data.results.hits.map(it => it._source) }))
        }
    }

    handleClose = () => {
        this.setState({ history: [] }, () => {
            this.props.popupStore.togglePopup(false)
        })
    }

    render() {
        const { info, popupType } = this.props.popupStore
        const { history } = this.state
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.handleClose}>סגור</Button>
            </div>
        )

        const columns = [
            {
                title: 'עורך',
                key: 'editor',
                align: 'right',
                width: 50,
                render: (_, row) => <span>{row.updatedBy}</span>
            },
            {
                title: 'בתאריך',
                key: 'date',
                align: 'right',
                width: 50,
                render: (_, row) => <span>{moment(row.date).format('DD/MM/YYYY')}</span>
            },
            {
                title: 'משקלים',
                key: 'weights',
                align: 'center',
                width: 200,
                render: (_, row) => (
                    <span style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                        {Object.entries(row.attributes).map(([key, value], idx) => (
                            <div key={idx} style={{ display: 'flex', flexDirection: 'column' }}>
                                <p>{weightsTexts[key]}</p>
                                <p>{value}%</p>
                            </div>
                        ))}
                    </span>
                )
            }
        ]
        return (
            <Modal
                title={`היסטוריית משקלי פרמטרים בחיפוש ${weightsTexts[info.type] + ' - ' + weightsTexts[info.subType]}`}
                visible={popupType === 'searchWeightHistory'}
                cancelText="ביטול"
                onCancel={this.handleClose}
                footer={footerButtons}
                width={1200}
            >
                <Table
                    loading={!history.length}
                    pagination={{
                        total: history.length,
                        pageSize: 10
                    }}
                    dataSource={history}
                    columns={columns}
                />
            </Modal>
        )
    }
}
